/*************************************************/
/* HEADER                                        */
/*************************************************/

export function header($body) {
    let $header;
    let menuNavParent = $(".menu-nav__item--parent");
    const megaMenuOpenClass = "open";

    const init = function () {
        $header = $(".header");

        $(window).on("scroll", function () {
            closeMegaMenu();
        });

        // Sticky header
        setStickyHeader();
        $(window).scroll(function () {
            setStickyHeader();
        });

        menuNavParent.click(function (e) {
            e.stopPropagation();
            if (!$(this).hasClass(megaMenuOpenClass)) {
                closeMegaMenu();
                $(this).addClass(megaMenuOpenClass);
                $header.addClass(megaMenuOpenClass);
            } else {
                $(this).removeClass(megaMenuOpenClass);
                $header.removeClass(megaMenuOpenClass);

            }
        });

        menuNavParent.find(".mega-menu").click(function (e) {
            e.stopPropagation();
        });
        $body.click(function () {
            closeMegaMenu();
        });

        const megaMenuVisualLinks = document.querySelectorAll(".mega-menu--visual a");
        if (megaMenuVisualLinks != null) {
            megaMenuVisualLinks.forEach(link => {
                link.addEventListener('mouseover', e => {
                    const linkInfoImage = link.dataset.infoimage;
                    const linkInfoText = link.dataset.infotext;
                    const infoImageElement = link.closest(".mega-menu--visual").querySelector(".mega-menu__info-image");
                    const infoTextElement = link.closest(".mega-menu--visual").querySelector(".mega-menu__info-text");

                    if (linkInfoImage != "") {
                        infoImageElement.src = linkInfoImage;
                    } else {
                        infoImageElement.src = "";
                    }
                    if (linkInfoText != "") {
                        infoTextElement.innerHTML = linkInfoText;
                    } else {
                        infoTextElement.innerHTML = "";
                    }
                });
            });
        }
    };

    init();

    function closeMegaMenu() {
        menuNavParent.removeClass(megaMenuOpenClass);
        $header.removeClass(megaMenuOpenClass);

        document.querySelectorAll(".mega-menu__info-image").forEach(element => {
            if (element.classList.contains("mega-menu__info-image--with-default")) {
                element.src = element.dataset.defaultimage;
            } else {
                element.src = "";
            }
        });
        document.querySelectorAll(".mega-menu__info-text").forEach(element => {
            if (element.classList.contains("mega-menu__info-text--with-default")) {
                element.innerHTML = element.dataset.defaulttext;
            } else {
                element.innerHTML = "";
            }
        });
    }


    function setStickyHeader() {
        if ($(window).scrollTop() > $header.height() / 2) {
            $body.addClass("header-sticky");
        } else {
            $body.removeClass("header-sticky");
        }
    }
}




// WEBPACK FOOTER //
// ./src/scripts/partials/header.js